// Период неделя с 00:00 до 23:59
export const periodWeek = (days) => {
    const now = new Date();
    const endOfDay = new Date(now);
    endOfDay.setHours(23, 59, 59, 999);

    const startOfDay = new Date(now);
    startOfDay.setDate(startOfDay.getDate() - 6);
    startOfDay.setHours(0, 0, 0, 0);

    return [startOfDay.getTime(), endOfDay.getTime()];
}

// Форматирование даты "2026-04-16"
export const msToLocalDate = (ms) => {
    const d = new Date(ms);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// Вывод в консоль abort
const handleFetchError = (err, logPrefix = '') => {
  if (err.name === 'AbortError') {
    console.log(`${logPrefix} signal is aborted`);
    return true; // возвращаем true, если это была ошибка прерывания
  } else {
    console.error(`${logPrefix}${err.message || err}`);
    return false;
  }
};